import React from "react"
import InboundMemberPaymentsForm from "./components/InboundMemberPaymentsForm"

export function InboundMemberPaymentsAmountFormPage(): JSX.Element {
  return <InboundMemberPaymentsForm />
}
